import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { jsx as _jsx } from "react/jsx-runtime";
const MissingPermissionState = ({
  selectedAssociationRecord
}) => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: "lock",
    illustrationProps: {
      width: 80
    },
    title: /*#__PURE__*/_jsx(H7, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'universalAssociationsSelect.searchResults.missingPermission.title',
        options: {
          pluralObjectName: selectedAssociationRecord.pluralObjectName
        }
      })
    }),
    marginBlock: "0",
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'universalAssociationsSelect.searchResults.missingPermission.description'
      })
    })
  });
};
export default MissingPermissionState;